import { Dayjs } from 'dayjs'
import { IPageMeta, IS3Response } from '../giveaway/giveaway-typed'
import { Transaction } from '../transaction/transaction-typed'
import { User } from '../user/user-typed'

export type IImportDcaFileBody = {
  file: File | null
  otpData: {
    otp?: string
    otpId?: string
  }
}

export type IImportDcaFileList = {
  items: IImportDcaFile[]
  meta: IPageMeta
}

export type IDcaRecordList = {
  items: IDcaRecord[]
  meta: IPageMeta
}

export interface IImportDcaFile {
  id: string
  createdAt: Date
  updatedAt: Date
  deletedAt: null
  fileName: string
  creatorId: string
  s3Response: IS3Response
  status: string
  summary: IImportDcaFileSummary
}

interface IImportDcaFileSummary {
  importDcaFileId: string
  total: number
  countPending: number
  countProcessing: number
  countSuccess: number
  countFail: number
}

export type IDcaRecord = {
  id: string
  createdAt: string
  updatedAt: string
  deletedAt: any
  userId: string
  amount: number
  status: EnumImportDcaRecordStatus
  type: string
  isvPaymentRef: string
  productRef1: string
  creatorId: string
  transactionId: string
  user: User
  transaction?: Transaction
  errorMessage?: string
}

export enum EnumFrequencyDcaType {
  MONTHLY = 'monthly',
  WEEKLY = 'weekly',
}

export enum EnumImportDcaRecordStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  SUCCESS = 'success',
  FAIL = 'fail',
}

export enum EnumImportDcaFileStatus {
  PENDING = 'pending',
  SUCCESS = 'success',
  FAIL = 'fail',
}

export type IExporDcaRecordReportParams = {
  startDate: Dayjs
  endDate: Dayjs
  status?: EnumImportDcaRecordStatus
}
